module.exports = __webpack_public_path__ + "static/media/empty.a1d60231.png";